import React from 'react';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';
import {useProjectsContext} from "@/pages/dashboard/ProjectsContext";

/**
 * TotalYear Component
 *
 * Displays a metric showing the total number of projects in the current view.
 * This is a simple counter that shows the count of filtered projects.
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.titleOnly] - Flag to show only title without delta value
 * @returns {JSX.Element} - A delta metric or loading indicator
 */
export default function TotalYear(props) {
  const {titleOnly} = props;
  const {filteredProjects, isLoading} = useProjectsContext();

  // Show loading state while projects are being fetched
  if (isLoading) {
    return (
      <MetricLoader
        name="Total"
      />
    );
  }

  // Render delta metric showing the total count of filtered projects
  // Delta is set to 0 since this is just a simple count without comparison
  return (
    <DeltaMetric
      name="Total"
      value={filteredProjects.length}
      delta={0}
      titleOnly={titleOnly}
    />
  );
}
